import { render, staticRenderFns } from "./DatosContactoPaciente.vue?vue&type=template&id=7ecf9c56&scoped=true"
import script from "./DatosContactoPaciente.vue?vue&type=script&lang=js"
export * from "./DatosContactoPaciente.vue?vue&type=script&lang=js"
import style0 from "./DatosContactoPaciente.vue?vue&type=style&index=0&id=7ecf9c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf9c56",
  null
  
)

export default component.exports